var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentView,{tag:"component",attrs:{"partId":_vm.partId,"newPart":_vm.newPart},on:{"save":function($event){return _vm.$emit('save', $event)},"cancel":function($event){return _vm.$emit('cancel')}}})}
var staticRenderFns = []

export { render, staticRenderFns }